import React from 'react';

function Hamburger() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 26 18"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 4,
    y: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    y: 8,
    rx: 1
  })));
}

export default Hamburger;